<template>
    <v-dialog :value="true" max-width="700" @input="$emit('close')">
        <v-card>
            <v-card-title>
                Kela-status: {{ transportEvent.orderId }}
                <v-spacer />
                <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <!-- Erätiedot -->
                <div v-if="batchInfo" class="mb-4">
                    <div class="subtitle-2 mb-1">Erätiedot</div>
                    <v-simple-table dense>
                        <tbody>
                            <tr><td><strong>Erä</strong></td><td>{{ batchInfo.siirtotunnus }}</td></tr>
                            <tr><td><strong>Alue</strong></td><td>{{ batchInfo.region }}</td></tr>
                            <tr><td><strong>TilitysNro</strong></td><td>{{ batchInfo.tilitysNro }}</td></tr>
                            <tr><td><strong>Vuosi</strong></td><td>{{ batchInfo.year }}</td></tr>
                            <tr><td><strong>Lähetetty</strong></td><td>{{ formatDateTime(batchInfo.sentAt) }}</td></tr>
                            <tr>
                                <td><strong>PAL-status</strong></td>
                                <td>
                                    <v-chip x-small :color="batchInfo.feedbackStatus === 'OK' ? 'green' : batchInfo.feedbackStatus ? 'red' : 'grey'">
                                        {{ batchInfo.feedbackStatus || 'Odottaa' }}
                                    </v-chip>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>
                <div v-else-if="batchLoading" class="text-center py-2">
                    <v-progress-circular indeterminate size="20" />
                </div>

                <v-divider class="mb-3" />

                <!-- Statushistoria -->
                <div class="subtitle-2 mb-2">Kela-statushistoria</div>

                <div v-if="historyLoading" class="text-center py-2">
                    <v-progress-circular indeterminate size="20" />
                </div>
                <div v-else-if="history.length === 0" class="grey--text text-caption">
                    Ei vielä TIL-statuksia.
                </div>
                <v-simple-table v-else dense>
                    <thead>
                        <tr>
                            <th>Tila</th>
                            <th>Muutosversio</th>
                            <th>Kelan päätös</th>
                            <th>Maksettu</th>
                            <th>Pyydetty</th>
                            <th>Hylkäysperuste</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in history" :key="row.id">
                            <td>
                                <v-chip x-small :color="statusColor(row.settlementStatus)">
                                    {{ row.settlementStatusLabel || statusLabel(row.settlementStatus) }}
                                </v-chip>
                            </td>
                            <td>{{ row.muutosversio || '—' }}</td>
                            <td>{{ formatDate(row.ratkaisupvm) }}</td>
                            <td>{{ row.maksettuKorvaus != null ? formatCurrency(row.maksettuKorvaus) : '—' }}</td>
                            <td>{{ row.haettuKorvaus != null ? formatCurrency(row.haettuKorvaus) : '—' }}</td>
                            <td>
                                <span class="text-caption" :title="row.rejectionInfo">
                                    {{ row.rejectionInfo ? row.rejectionInfo.substring(0, 50) + (row.rejectionInfo.length > 50 ? '…' : '') : '—' }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from "moment";
import kelaBatchRepository from "@/data/repositories/kelaBatchRepository";

export default {
    name: "KelaStatusPopup",
    props: {
        transportEvent: { type: Object, required: true }
    },
    data() {
        return {
            history: [],
            historyLoading: false,
            batchInfo: null,
            batchLoading: false
        };
    },
    created() {
        this.loadHistory();
        this.loadBatchInfo();
    },
    methods: {
        async loadHistory() {
            this.historyLoading = true;
            try {
                const r = await kelaBatchRepository.getTransportEventStatuses(this.transportEvent.id);
                this.history = r.data || [];
            } catch { this.history = []; } finally { this.historyLoading = false; }
        },
        async loadBatchInfo() {
            if (!this.transportEvent.id) return;
            this.batchLoading = true;
            try {
                const r = await kelaBatchRepository.search({ TransportEventId: this.transportEvent.id, Top: 1, Page: 1 });
                this.batchInfo = r.data?.results?.[0] ?? null;
            } catch { this.batchInfo = null; } finally { this.batchLoading = false; }
        },
        statusColor(status) {
            const c = { M: "green",
                H: "red",
                O: "orange",
                K: "blue-grey",
                T: "orange",
                P: "amber darken-2",
                X: "deep-orange",
                L: "blue" };
            return c[status] ?? "grey";
        },
        statusLabel(status) {
            const l = { M: "Myöntö",
                H: "Hylkäys",
                O: "Osamyöntö",
                K: "Kesken",
                T: "Korvausta muutettu",
                P: "Palautettu käsittelyyn",
                X: "Takaisinperintä",
                L: "Lisäsuoritus" };
            return l[status] ?? status;
        },
        formatDate(v) { return v ? moment(v).format("DD.MM.YYYY") : "—"; },
        formatDateTime(v) { return v ? moment(v).format("DD.MM.YYYY HH:mm") : "—"; },
        formatCurrency(v) {
            return new Intl.NumberFormat("fi-FI", { style: "currency", currency: "EUR" }).format(v);
        }
    }
};
</script>
